module.exports = __webpack_public_path__ + "img/succeed.7591b3ae.png";